const TYPES = {
  TEXT: 'text',
  PASSWORD: 'password',
};

export { TYPES };
